import { Theme } from "@mui/material";

// ----------- Custom Stepper Icon Button --------------
export const customIconCircleStyles = {
  width: 44,
  height: 44,
  borderRadius: "50%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

// --------- Vertical Styles
export const fleetInquiryIconStyles = {
  "& svg": {
    width: "100%",
    transform: "translateX(-5px)",
  },
};

// --------- Horizontal Styles
export const getFleetInquiryHorizontalIconStyles = (index: number) => ({
  "& svg": {
    transform: `${index === 0
      ? `translate(-4px,-5px)`
      : index === 1
        ? `translate(0px,-5px)`
        : index === 3
          ? `translate(8px,-5px)`
          : index === 4
            ? `translate(28px,-5px)`
            : `translate(0px,-5px)`
      }`,
  },
});

// --------- Vertical Styles
export const fleetInquiryTextStyles = {
  padding: "10px 36px 10px 16px",
  background: "#F7F8FA",
  whiteSpace: "nowrap",
  borderRadius: "6px",
};

//------Horizontal styles
export const fleetInquiryHorizontalTextStyles = {
  padding: "10px 16px",
  background: "#F7F8FA",
  borderRadius: "6px",
};

// --------- Vertical Stepper Label styles
export const getStepLabelStyles = (iconSize: number) => ({
  "& .MuiStepLabel-label": {
    transform: `translateX(calc(-100% - ${iconSize + 16}px))`,
    width: "fit-content",
    borderRadius: "6px",
  },
});

// --------- Vertical Stepper Content styles
export const stepperContentStyles = {
  maxWidth: { md: 368 },
  bgcolor: "white",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translateY(-50%)",

  "&.MuiStepContent-root": {
    borderLeft: "none",
  },
};

// ----------- Fleet Inquiry details List styles
export const fleetInquiryDetailsStyles = {
  display: "flex",
  flexDirection: "column",
  gap: { xs: 1, md: 2 },
  listStyleType: "disc",
  pl: 2,
  mb: { xs: 3, md: 6 },
};

export const getListItemStyles = (theme: Theme) => ({
  display: "list-item",
  "&::marker": {
    color: theme.palette.primary.main,
  },
});

// -----------Vertical Stepper styles
export const getStepperStyles = (theme: Theme, iconSize: number) => ({
  paddingLeft: `calc(50% - ${iconSize}px)`,

  "& .MuiStepLabel-iconContainer .custom-icon": {
    bgcolor: "#F9FAFC",
    border: "1px solid #EDEDED",
  },
  "& .MuiStepLabel-iconContainer.Mui-active .custom-icon": {
    bgcolor: `${theme.palette.text.primary}`,
    border: `1px solid ${theme.palette.text.primary}`,
  },

  "& .MuiStepLabel-iconContainer.Mui-active .custom-icon .custom-icon-text": {
    color: "white",
  },

  "& .MuiStepLabel-iconContainer.Mui-completed": {
    color: "white",
  },

  "& .MuiStepLabel-iconContainer.Mui-completed .custom-icon": {
    bgcolor: `${theme.palette.text.primary}`,
    border: `1px solid ${theme.palette.text.primary}`,
  },

  "& .MuiStepConnector-root": {
    ml: 2.75,
  },

  "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
    borderColor: "black",
  },

  "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
    borderColor: "black",
  },
});

//-------------- Horizontal Stepper Label styles
export const getHorizontalStepperLabelStyles = (
  index: number,
  iconSize: number
) => ({
  "& .MuiStepLabel-label": {
    position: "absolute",
    bottom: `calc(-100% + ${iconSize + 48}px)`,
    left: `${index === 0
      ? "-12px"
      : index === 1 || index === 2 || index === 3
        ? "-32px"
        : "-64px"
      }`,
    borderRadius: "6px",
  },
});

//------------ Horizontal Stepper styles
export const getHorizontalStepperStyles = (theme: Theme, iconSize: number) => ({
  paddingTop: `${iconSize + 48}px`,
  mb: 4,

  "& .MuiStepLabel-iconContainer .custom-icon": {
    bgcolor: "#F9FAFC",
    border: "1px solid #EDEDED",
  },
  "& .MuiStepLabel-iconContainer.Mui-active .custom-icon": {
    bgcolor: `${theme.palette.text.primary}`,
    border: `1px solid ${theme.palette.text.primary}`,
  },

  "& .MuiStepLabel-iconContainer.Mui-active .custom-icon .custom-icon-text": {
    color: "white",
  },

  "& .MuiStepLabel-iconContainer.Mui-completed .custom-icon": {
    bgcolor: `${theme.palette.text.primary}`,
    border: `1px solid ${theme.palette.text.primary}`,
  },

  "& .MuiStepLabel-iconContainer.Mui-completed": {
    color: "white",
  },

  "& .MuiStepConnector-root": {
    mt: 1.25,
  },

  "& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line": {
    borderColor: "black",
  },

  "& .MuiStepConnector-root.Mui-active .MuiStepConnector-line": {
    borderColor: "black",
  },
});
